import { ChevronRight } from "lucide-react";
import type { ConditionSearchHit } from "../../types";
import { TagPill } from "../Pills";

interface ConditionResultRowProps {
  hit: ConditionSearchHit;
  onPick: (hit: ConditionSearchHit) => void;
  children?: never;
}

/**
 * One condition in a search result or browse list. Clicking it is the pick; there is no multi-select. Only Custom and Inactive
 * are called out: a condition from the manual needs no label (feedback 6.4), and the manual's "See X" pointers are not rows
 * any more (the smart tier finds the target from the shorthand instead).
 */
export function ConditionResultRow({ hit, onPick }: ConditionResultRowProps) {
  return (
    <li>
      <button type="button" onClick={() => onPick(hit)} className="flex min-h-[44px] w-full cursor-pointer items-center gap-3 rounded-lg px-2 py-2 text-left hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brand-green-50">
        <span className="min-w-0 flex-1">
          <span className="flex flex-wrap items-center gap-2">
            <span className="font-medium text-gray-800">{hit.name}</span>
            {hit.isCustom && <TagPill label="Custom" tone="green" />}
            {!hit.isActive && <TagPill label="Inactive" />}
            {hit.matchedText && <span className="text-xs text-gray-500">matched {hit.matchedText}</span>}
          </span>
        </span>
        <span className="shrink-0 text-xs tabular-nums text-gray-500">{hit.selectionCount} selections</span>
        <ChevronRight size={16} className="shrink-0 text-gray-400" aria-hidden="true" />
      </button>
    </li>
  );
}
